import React from 'react';
import hollyImage from 'url:../assets/holly-best-men.png';
import katImage from 'url:../assets/kat-moh.jpeg';
import judeImage from 'url:../assets/jude-bridal-party.jpeg';
import benImage from 'url:../assets/ben-celebrant.jpeg';

interface WeddingPerson {
  name: string;
  role: string;
  img: string;
  description: string;
  subDescription?: string;
}

const celebrant: WeddingPerson[] = [
  {
    name: 'Ben Borowiecki',
    role: '"The Chronicler"',
    img: benImage,
    description: 'Every great quest needs a narrator. In some realms, they\'d be a warlock sealing contracts with demons.',
    subDescription: 'Here, they seal contracts with vows. It\'s slightly less dangerous, but just as permanent.',
  },
];
const groomPeople: WeddingPerson[] = [
  {
    name: 'Holly Taylor',
    role: '"The Emotional Heavy"',
    img: hollyImage,
    description: 'The watcher of the inner circle and keeper of the family secrets. When the noise gets loud and the heat is on, she minds what matters most.',
    subDescription: 'If things get heavy, she carries the weight; if the drama gets loud, she makes it "disappear."',
  },
];
const bridePeople: WeddingPerson[] = [
  {
    name: 'Kat Price',
    role: '"The Right Hand of the Bride"',
    img: katImage,
    description: 'The Bride\'s other life partner. Has the Bride\'s ear at all times, and occasionally her wine glass too.',
    subDescription: 'If you need something from the Bride today, talk to the Hand.',
  },
  {
    name: 'Judith Durkin',
    role: '"The Enforcer"',
    img: judeImage,
    description: 'She has a list, a watch, and a clipboard. If you hear your name coming from this woman, you\'re needed somewhere.',
    subDescription: 'Shame she didn\'t send us a photo of her face. Best of luck.',
  },
];

const WeddingGrid: React.FC = () => {
  return (
    <>
      <article className="block-content block-content-longtext">
        <p>We’ve always believed that family isn't just about who you’re born to; it’s about who’s willing to help you bury a body at 3am, no questions asked. One of them would probably advise us on what to plant over the burial site to get a good harvest.</p>

        <p>Jokes aside, we are incredibly blessed to have a massive crew of both blood and chosen family.</p>

        <p>These are people who stood by us through thick and thin, and today they’re standing with us to make sure this whole operation goes off without a hitch. They’re here to ensure we make good on an offer we can’t refuse: till death do us part.</p>
      </article>
      <article className="block-content block-content-longtext block-content-wide">
        <h2>The Bridal Party</h2>
        <div className="wedding-grid">
          {bridePeople.map((p) => (
            <div key={p.name} className="wedding-card">
              <div className="wedding-image" style={{ backgroundImage: `url(${p.img})` }} />
              <div className="wedding-info">
                <strong>{p.name}</strong>
                <div className="role">{p.role}</div>
                <p>{p.description}</p>
                {p.subDescription && (
                  <p>{p.subDescription}</p>
                )}
              </div>
            </div>
          ))}
        </div>

        <h2>The Best <span className="minipadded"></span>"Man"</h2>
        <div className="wedding-grid wedding-grid--single">
          {groomPeople.map((p) => (
            <div key={p.name} className="wedding-card">
              <div className="wedding-image" style={{ backgroundImage: `url(${p.img})` }} />
              <div className="wedding-info">
                <strong>{p.name}</strong>
                <div className="role">{p.role}</div>
                <p>{p.description}</p>
                {p.subDescription && (
                  <p>{p.subDescription}</p>
                )}
              </div>
            </div>
          ))}
        </div>

        <h2>The Celebrant</h2>
        <div className="wedding-grid wedding-grid--single">
          {celebrant.map((p) => (
            <div key={p.name} className="wedding-card">
              <div className="wedding-image" style={{ backgroundImage: `url(${p.img})` }} />
              <div className="wedding-info">
                <strong>{p.name}</strong>
                <div className="role">{p.role}</div>
                <p>{p.description}</p>
                {p.subDescription && (
                  <p>{p.subDescription}</p>
                )}
              </div>
            </div>
          ))}
        </div>

      </article>
    </>
  );
};

export default WeddingGrid;
